export const normalizePermissions = (rawPermissions = {}) => ({
  dashboard: Boolean(rawPermissions.dashboard ?? rawPermissions.Dashboard),
  dashboardChart: Boolean(
    rawPermissions.dashboardChart ??
      rawPermissions.DashboardChart ??
      rawPermissions.dashboard ??
      rawPermissions.Dashboard
  ),
  notifications: Boolean(
    rawPermissions.notifications ??
      rawPermissions.Notifications ??
      rawPermissions.dashboard ??
      rawPermissions.Dashboard
  ),
  masterAnalytics: Boolean(
    rawPermissions.masterAnalytics ??
      rawPermissions.MasterAnalytics ??
      rawPermissions.admin ??
      rawPermissions.Admin
  ),
  orders: Boolean(rawPermissions.orders ?? rawPermissions.Orders),
  invoiceSystem: Boolean(rawPermissions.invoiceSystem ?? rawPermissions.InvoiceSystem),
  riders: Boolean(rawPermissions.riders ?? rawPermissions.Riders),
  customers: Boolean(rawPermissions.customers ?? rawPermissions.Customers),
  contact: Boolean(
    rawPermissions.contact ??
      rawPermissions.Contact ??
      rawPermissions.dashboard ??
      rawPermissions.Dashboard ??
      rawPermissions.admin ??
      rawPermissions.Admin
  ),
  priceManipulation: Boolean(
    rawPermissions.priceManipulation ?? rawPermissions.PriceManipulation
  ),
  approveARider: Boolean(
    rawPermissions.approveARider ??
      rawPermissions.approveRider ??
      rawPermissions.ApproveRider
  ),
  transaction: Boolean(rawPermissions.transaction ?? rawPermissions.Transactions),
  couponsAndOffers: Boolean(
    rawPermissions.couponsAndOffers ?? rawPermissions.CouponsAndOffers
  ),
  chats: Boolean(rawPermissions.chats ?? rawPermissions.Chats),
  logging: Boolean(
    rawPermissions.logging ??
      rawPermissions.Logging ??
      rawPermissions.admin ??
      rawPermissions.Admin
  ),
  crm: Boolean(
    rawPermissions.crm ??
      rawPermissions.CRM ??
      rawPermissions.admin ??
      rawPermissions.Admin
  ),
  mapAccess: Boolean(rawPermissions.mapAccess ?? rawPermissions.MapAccess),
  moneyController: Boolean(
    rawPermissions.moneyController ?? rawPermissions.MoneyController
  ),
  admin: Boolean(rawPermissions.admin ?? rawPermissions.Admin),
  signup: Boolean(
    rawPermissions.signup ??
      rawPermissions.signUp ??
      rawPermissions.signin ??
      rawPermissions.signIn ??
      rawPermissions.SignUp ??
      rawPermissions.SignIn
  ),
  city: Boolean(rawPermissions.city ?? rawPermissions.City),
});

export const safeReadPermissionsFromStorage = () => {
  const permissionsStr = localStorage.getItem("userPermissions");
  if (!permissionsStr) return null;

  try {
    return normalizePermissions(JSON.parse(permissionsStr));
  } catch (error) {
    console.error("Error parsing userPermissions:", error);
    return null;
  }
};

export const permissionRoutePriority = [
  { key: "dashboardChart", path: "/dashboardNew" },
  { key: "dashboard", path: "/dashboard" },
  { key: "notifications", path: "/notifications" },
  { key: "masterAnalytics", path: "/master-analytics" },
  { key: "orders", path: "/orders?query=processing" },
  { key: "invoiceSystem", path: "/invoices" },
  { key: "riders", path: "/riders?query=active" },
  { key: "customers", path: "/customers" },
  { key: "contact", path: "/contact" },
  { key: "priceManipulation", path: "/price-manipulation" },
  { key: "approveARider", path: "/pending" },
  { key: "transaction", path: "/transaction" },
  { key: "couponsAndOffers", path: "/coupons-and-offers" },
  { key: "chats", path: "/admin/chat" },
  { key: "logging", path: "/logging" },
  { key: "crm", path: "/crm-settings" },
  { key: "admin", path: "/admins" },
  { key: "signup", path: "/signup" },
];

export const getFirstAccessibleRoute = (permissions, fallback = "/unauthorized") => {
  for (const item of permissionRoutePriority) {
    if (permissions?.[item.key]) {
      return item.path;
    }
  }
  return fallback;
};
